import type { Employee } from "@pentacode/core";
import { LitElement, html } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { live } from "lit/directives/live.js";
import "../components/avatar/avatar";
import { app } from "../init";
import "./employee-list";
import type { EmployeeList } from "./employee-list";
import "./popover";
import type { Popover } from "./popover";

@customElement("ptc-employee-select")
export class EmployeeSelect extends LitElement {
    @property()
    name: string;

    @property({ type: Boolean })
    required: boolean;

    @property({ type: Boolean })
    readonly = false;

    @property({ type: Number })
    employeeId: number | null = null;

    @property()
    placeholder = "Mitarbeiter Wählen...";

    get employee() {
        return app.getEmployee(this.employeeId);
    }

    @query("ptc-employee-list")
    private _employeeList: EmployeeList;

    @query("ptc-popover")
    private _listPopover: Popover;

    private _employeeSelected(e: CustomEvent<{ employee: Employee }>) {
        this.employeeId = e.detail.employee.id;
        this._listPopover.hide();
    }

    createRenderRoot() {
        return this;
    }

    render() {
        const tab = this.readonly ? -1 : 0;
        return html`
            <div class="padded box ${this.readonly ? "" : "click"} relative" tabindex=${tab} style="overflow: visible">
                <div class="spacing center-aligning horizontal layout">
                    <ptc-avatar class="tinier" .employee=${this.employee}></ptc-avatar>
                    <div class="stretch ellipsis">${this.employee?.name || this.placeholder}</div>
                    <ptc-ui-icon name="icon.navigation.dropdown" ?hidden=${this.readonly}></ptc-ui-icon>
                </div>

                ${this.readonly
                    ? ""
                    : html`<ptc-popover
                          .preferAlignment=${["bottom"]}
                          @popover-show=${() => this._employeeList.focus()}
                      >
                          <ptc-employee-list
                              style="width: 20em; height: 30em;"
                              .employee=${live(this.employee)}
                              @change=${this._employeeSelected}
                          ></ptc-employee-list>
                      </ptc-popover>`}
                <input
                    type="number"
                    name=${this.name}
                    ?required=${this.required}
                    .value=${live(this.employeeId?.toString() || "")}
                    class="fill"
                    style="position: absolute; top: 0; opacity: 0; box-sizing: border-box; pointer-events: none;"
                />
            </div>
        `;
    }
}
